import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, IconButton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { TableActionsContainer } from 'shared/domains/common-ui';
import { Assistant } from './Assistant';
import { BulkChangeStatus } from './BulkChangeStatus';
import { BulkMove } from './BulkMove';
import { BulkSetMetadata } from './BulkSetMetadata';
import { useTableContext } from '../SearchResultsTable/TableContext';
export function TableBulkActions() {
    const { selected, setSelected } = useTableContext();
    const selectedCount = selected.length;
    const reset = () => setSelected({ type: 'reset' });
    return (<TableActionsContainer show={selectedCount > 0}>
      <Box alignItems="center" gap="sm" mr="md">
        <Falcon $color="gray.100" icon="file"/>
        <Typography $color="gray.100" $fontSize="small" $fontWeight="semibold">
          <Trans comment="Bulk action: Selected count">{selectedCount} selected</Trans>
        </Typography>
      </Box>

      <BulkChangeStatus />

      <BulkSetMetadata />

      <BulkMove />

      <Assistant />

      <IconButton size="small" appearance="primary" onClick={reset} aria-label={t({ message: 'Deselect all', comment: 'Bulk action: Deselect all button' })}>
        <Falcon icon="xmark"/>
      </IconButton>
    </TableActionsContainer>);
}
